import { render, staticRenderFns } from "./TablePrice.vue?vue&type=template&id=2c17e9b2"
import script from "./TablePrice.vue?vue&type=script&lang=js"
export * from "./TablePrice.vue?vue&type=script&lang=js"
import style0 from "./TablePrice.vue?vue&type=style&index=0&id=2c17e9b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports